module.exports = __webpack_public_path__ + "static/media/footer_image.9a280574.jpg";